import * as d3 from 'd3';

export function drawColonialGrillsOculus(
  svg,
  x,
  y,
  width,
  height,
  frameWidth = 10,
  horLines = 1,
  verLines = 1,
  lineColor = 'white',
  borderColor = 'black',
  borderWidth = 0.2,
  grillThickness = 2,
  radiusX = width / 2,
  radiusY = height / 2,
  outerShape = 'Rect'
) {
  const glassX = x;
  const glassY = y;
  const glassWidth = width;
  const glassHeight = height;

  // ALWAYS clip grills to the inner glass ellipse (oculus is always a circle/oval)
  const clipId = `ellipseClip_${Math.random().toString(36).substr(2, 9)}`;
  const centerX = glassX + glassWidth / 2;
  const centerY = glassY + glassHeight / 2;

  svg.append('defs')
    .append('clipPath')
    .attr('id', clipId)
    .append('ellipse')
    .attr('cx', centerX)
    .attr('cy', centerY)
    .attr('rx', radiusX)
    .attr('ry', radiusY);

  const grillGroup = svg.append('g')
    .attr('clip-path', `url(#${clipId})`);

  // Vertical grills
  for (let i = 1; i <= verLines; i++) {
    const gx = glassX + (glassWidth * i) / (verLines + 1);
    grillGroup.append('rect')
      .attr('x', gx - grillThickness / 2)
      .attr('y', glassY)
      .attr('width', grillThickness)
      .attr('height', glassHeight)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);
  }

  // Horizontal grills
  for (let i = 1; i <= horLines; i++) {
    const gy = glassY + (glassHeight * i) / (horLines + 1);
    grillGroup.append('rect')
      .attr('x', glassX)
      .attr('y', gy - grillThickness / 2)
      .attr('width', glassWidth)
      .attr('height', grillThickness)
      .attr('fill', lineColor)
      .attr('stroke', borderColor)
      .attr('stroke-width', borderWidth);
  }
}
  